import { ITextField, PrimaryButton, Spinner, Stack, TextField } from '@fluentui/react';
import { useRef, useState } from 'react';

import { popup } from '../../../addons/Popup';
import { postAsync } from '../../../utils/api';

export default () => {
  const inputRef = useRef<ITextField | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <div style={{ width: "20vw", padding: "1rem" }}>
      <Stack tokens={{ childrenGap: 10 }}>
        <TextField
          type="password"
          componentRef={(r) => (inputRef.current = r)}
          label="Sistemdeki E-Finans Şifresi"
        />
        <PrimaryButton
          text="Güncelle"
          disabled={loading}
          onClick={() => {
            const value = inputRef.current?.value;
            if (!value) return;

            setLoading(true);

            postAsync("/invoices/set-password", { password: value })
              .then(() => {
                setLoading(false);
                popup("E-Finans şifresi başarıyla güncellendi.");
              })
              .catch(() => {
                setLoading(false);
                popup("E-Finans şifresi güncellenirken bir hata oluştu.");
              });
          }}
        />
        {loading && <Spinner />}
      </Stack>
    </div>
  );
};
